import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";
import { useBuildingDetailQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — heavy BuildingDetail page lazy-loaded; the wrapper
// stays eager so SiteHeader hydrates with the building name before the
// page chunk finishes downloading.
const BuildingDetail = lazy(() => import("@/pages/BuildingDetail/Page"));

const BuildingView = () => {
  const { buildingId } = Route.useParams();
  const { data } = useBuildingDetailQuery(buildingId);
  return (
    <div className="flex flex-col w-full">
      <SiteHeader
        header={data?.name || data?.full_address || "Building"}
        backLink="/buildings"
      />
      <Suspense fallback={null}>
        <BuildingDetail buildingId={buildingId} />
      </Suspense>
    </div>
  );
};

type BuildingViewSearch = {
  stage?: number;
};
export const Route = createFileRoute("/buildings/$buildingId")({
  component: BuildingView,
  validateSearch: (search?: Record<string, unknown>): BuildingViewSearch => ({
    stage:
      typeof search?.stage !== "undefined" ? Number(search?.stage) : undefined,
  }),
});
